import styled, { css } from "styled-components";

export const RadioGroupWrapper = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `
);
